<template>
    <div class="order-item">
        <div>
            <div class="order-item__header">
                <div style="flex:1" class="flex-center-default">
                    <span class="order-num">
                        <TextFormat :text="'#' + data.pickupCode" class="order-item__label-bold"></TextFormat>
                    </span>
                    <span class="order-item__value" style="margin-left: 10px;">
                        <TextFormat :text="data.merchant" class="order-item__label-bold"></TextFormat>
                    </span>
                    <span v-if="showStatus" class="order-status" :class="statusClass">
                        {{ statusText }}
                    </span>

                </div>


            </div>
            <div class="order-item__info">
                <span class="order-item__label">下单时间</span>
                <span class="order-item__value">
                    <TimeFormat :value="data.orderTime" format="MM-DD HH:mm" />
                </span>
            </div>

            <div>
                <div class="order-item__info">
                    <span class="order-item__label">订单编号</span>
                    <span class="order-item__value">{{ data.code }}</span>
                    <span v-if="data.partSize && data.partSize > 1" style="margin-left:10px;">({{
                        `${data.partNo}/${data.partSize}`
                        }})</span>
                </div>
            </div>

            <div class="flex-center-default order-item-row">
                <div class="order-item__info" style="margin-right: 10px;">
                    <span class="order-item__label">手机号</span>
                    <span class="order-item__value">{{ data.userPhone }}</span>
                </div>
                <!-- <div class="order-item__info">
          <span class="order-item__label">下单时间</span>
          <span class="order-item__value">
            <TimeFormat :value="data.orderTime" format="MM-DD HH:mm" />
          </span>
        </div> -->

            </div>

            <div>
                <div class="order-item__info order-info-content">
                    <span class="order-item__label">订单内容</span>
                    <span class="order-item__value">{{ data.content }}</span>
                </div>
            </div>
            <div>
                <div class="order-item__info">
                    <span class="order-item__label">重量</span>
                    <span class="order-item__value">{{ data.weight }}kg</span>
                </div>
            </div>
            <div v-if="showFooter" class="action-group">
                <!-- <el-popconfirm v-if="data.status === '0'" title="确认接单吗？" @confirm="handleAccept">
          <span slot="reference" class="order-action">
            确认接单
          </span>
        </el-popconfirm> -->

                <span v-if="data.status === TakeoutOrderStatus.PENDING_MEAL.value" class="order-action"
                    @click.stop="handleAccept">
                    确认接餐
                </span>
                <el-popconfirm v-if="cancelBtnVisible" title="确认取消吗？" @confirm="handleCancel">
                    <span slot="reference" class="order-action cancel-btn">
                        取消拆单
                    </span>
                </el-popconfirm>
                <el-popover v-if="splitBtnVisible" v-model="popoverVisible" trigger="click"
                    popper-class="c-el-popover-blue opacity-1 custom-order-popconfirm " placement="top" width="300">
                    <span slot="reference" class="order-action">
                        拆分订单
                    </span>
                    <div style="padding:12px">
                        <div>

                            <el-form ref="splitForm" label-width="80px" :model="formData" :rules="rules">
                                <el-form-item label="拆分数量" prop="splitNum">
                                    <el-input-number v-model="formData.splitNum" class="c-el-input-number-blue"
                                        style="width: 100%;" :min="2" :max="5" placeholder="请输入拆分数量" step-strictly
                                        :precision="0" />
                                </el-form-item>
                            </el-form>


                            <el-alert :title="splitConfirmTitle" type="warning" :closable="false">
                            </el-alert>


                        </div>
                        <div style="text-align: right; margin-top: 20px">
                            <el-button size="mini" type="text" @click="popoverVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="handleSplitConfirm">确定</el-button>
                        </div>
                    </div>
                </el-popover>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 订单项list item组件
 */
import TimeFormat from '@/components/TimeFormat';
import { TakeoutOrderStatus } from '@/page/business/wuliu/constants';
import TextFormat from '@/components/text-format';

export default {
    name: 'OrderItem',
    components: {
        TimeFormat,
        TextFormat,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        showSplitBtn: {
            type: Boolean,
            default: true,
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
        showStatus: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            TakeoutOrderStatus,
            formData: {
                splitNum: 2,
            },
            splitConfirmTitle: '如果一个飞行架次不能配送完该外卖订单，需要拆分订单，否则不需要进行拆分订单，确认拆分吗？',
            popoverVisible: false,
            rules: {
                splitNum: [
                    { required: true, type: 'number', message: '请输入拆分数量', trigger: 'blur' },
                    { min: 2, max: 5, type: 'number', message: '拆分数量必须在2-5之间', trigger: 'blur' },
                ],
            },
        };
    },
    computed: {
        statusText() {
            if (!this.data) {
                return '';
            }
            // if (this.data.orderStatus === 1) {
            //   return '待接单'
            // } else if (this.data.orderStatus === 2) {
            //   return '已接单'
            // }
            return this.data.statusLabel;
        },
        statusClass() {
            if (!this.data) {
                return '';
            }
            if (this.data.status === TakeoutOrderStatus.PENDING_MEAL.value) {
                return 'order-status__pending';
            } else if (this.data.status === TakeoutOrderStatus.ACCEPTED.value) {
                return 'order-status__success';
            }
        },
        splitBtnVisible() {
            const { status, isPart } = this.data
            return this.showSplitBtn && status === TakeoutOrderStatus.ACCEPTED.value && !isPart
        },
        cancelBtnVisible() {
            const { status, isPart, partSize } = this.data
            return this.showSplitBtn && status === TakeoutOrderStatus.ACCEPTED.value && partSize > 1
        },
    },
    methods: {
        handleAccept() {
            console.log('accept order', this.data);
            this.$emit('accept', this.data);
        },
        handleSplitConfirm() {
            this.$refs.splitForm.validate((valid) => {
                if (valid) {
                    this.handleSplit()
                } else {
                    console.log('校验失败');
                }
            });
        },
        handleSplit() {
            this.popoverVisible = false;
            this.$emit('splitClick', { data: this.data, formData: this.formData });
        },
        handleCancel() {
            this.$emit('cancelClick', this.data);
        },

    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
$colorLight: #5bf0fc;
$borderColor: #2e355b;

.order-item {
    color: #49F0FD;
    line-height: 1.5;
    padding: 16px 3px;

    &__header {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .order-num {
        font-size: 14px;
        color: $colorLight;
        font-weight: bold;
        // flex: 1
    }

    .order-status {
        font-size: 12px;
        padding: 2px 4px;
        color: #ffffff;
        margin-left: auto;
        background-color: #0084FF50;
        border: #0084FF 1px solid;
        border-radius: 2px;
        flex-shrink: 0;

        &__success {
            border: #0084FF 1px solid;
            background-color: #0084FF50;
        }

        &__pending {
            border: #FFEC3D 1px solid;
            background-color: #FFEC3D50
        }
    }

    .action-group {
        position: relative;
        margin-top: 8px;
        text-align: right;
        max-height: 28px;
    }

    .order-action {
        font-size: 12px;
        padding: 2px 6px;
        color: $colorLight;
        border: 1px solid $colorLight;
        margin-left: 10px;
        // background-color: rgba(91, 240, 252, 0.1);
        background: rgba(73, 240, 253, 0.1);

        border-radius: 4px;
        flex-shrink: 0;
        cursor: pointer;
    }

    .cancel-btn {
        color: rgba(255, 255, 255, 0.8);
        border: 1px solid $borderColor;
        background: transparent;
    }

    &-row {
        flex-wrap: wrap;
    }

    &__info {
        &+.order-item__info {
            // margin-left: 10px;
        }
    }

    &__title {
        width: 60px;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        margin-right: 8px;
        // text-align-last: justify;
        // &::after {
        //     content: "：";
        //     margin-left: 2px;
        //     /* 冒号和文字之间留点空隙 */

        // }
    }

    &__label {
        color: #D0D0D0;
        position: relative;
        width: 60px;
        display: inline-block;
        /* 文字两端对齐（针对多字标签） */
        // text-align-last: justify;
        font-size: 14px;
        margin-right: 8px;

        // &::after {
        //     content: "：";
        //     margin-left: 2px;
        //     /* 冒号和文字之间留点空隙 */

        // }
        &-bold {
            font-weight: 700;
            font-size: 20px;
        }
    }

    &__value {
        font-size: 14px;
    }
}
</style>
<style lang="scss">
.custom-order-popconfirm {
    .el-form-item__label {
        color: #ffffff;
    }

    .el-alert--warning.is-light {
        background-color: transparent
    }
}
</style>
